/**
 * AI Assistant Store
 */

import { createStore } from '@commandDrivenStateEngine/core/createStore';
import { initialState } from './state';
import { handlers } from './handlers';
import { invariants } from './invariants';
import { createBackendPolicy } from './policies/backendPolicy';
import { createPlanExecutorPolicy } from './policies/planExecutorPolicy';
import { createAutoExecutePolicy } from './policies/autoExecutePolicy';
import { createApprovalPolicy } from './policies/approvalPolicy';
import { createConversationHistoryPolicy } from './policies/conversationHistoryPolicy';
import { createFeedbackPolicy } from './policies/feedbackPolicy';
import { AIAssistantService } from '@infrastructure/aiAssistant/aiAssistantService';
import { ClientLibraryType, RealtimeSession } from '@bett3r-dev/teselly-client-library';

export { selectors } from './state';

const store = createStore({
  name: 'ai-assistant',
  initialState,
  handlers,
  invariants
});

export const {
  useSelector: useAIAssistantSelector,
  useErrors: useAIAssistantErrors,
  useDispatch: useAIAssistantDispatch,
  usePolicies: useAIAssistantPolicies,
  getState: getAIAssistantState,
  dispatch: dispatchAIAssistantCommand
} = store;

/**
 * Policy factory - creates policies that require service dependencies
 */
export const createAIAssistantPolicies = (
  service: AIAssistantService,
  backend: ClientLibraryType,
  realtimeSession: RealtimeSession | null
) => [
  createBackendPolicy( service, realtimeSession ),
  createPlanExecutorPolicy( backend ),
  createAutoExecutePolicy(),
  createApprovalPolicy( backend, realtimeSession ),
  createConversationHistoryPolicy( service ),
  createFeedbackPolicy( service )
];
